/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { AttributeInputCallback, Callback, CallbackType } from "@forgerock/javascript-sdk";
// import { City, Country, State } from "country-state-city";
import Country from "country-state-city/lib/country";
import State from "country-state-city/lib/state";
import { ICountry } from "country-state-city/lib/interface";
// import { isNil } from "lodash";
import isNil from 'lodash/isNil';
import { CheckboxButtonGroup, MultiSelectElement, PasswordElement, SelectElement, TextFieldElement } from "react-hook-form-mui";
import FormSection from "../components/01-atoms/FormSection";
import MultivalueText from "../components/02-molecules/MultivalueText";
import { job_functions, portals, types_roles } from "../data";
import { callRender } from "../redux/reRenderSlice";
import { store } from "../redux/store";
import CustomCheckBox from "./component/CustomCheckBox";
import CustomPasswordElement from "./component/customPasswordElement";
import CustomSelectField from "./component/CustomSelectField";
import CustomTextField from "./component/CustomTextField";
import CustomFormRadioGroup from "./component/RadioGroup";
import TelephoneInput from "./component/TelephoneInput";
import styles from '../styles/FormLayout.module.css';
import CustomMultiSelectComponent from "./component/customMultiSelectField";
import CustomCheckBoxGroup from "./component/CustomCheckBoxGroup";




const ar = true; // Activate Required (can turn off for testing convenience)
const countries = Country.getAllCountries();
let states =State.getAllStates()
let cities: any;
let countryIsoCode: string;

export const setInitalValues = (stateValue: any, citiesValue: any, countryIsoCodeValue: any) => {
    states = stateValue;
    cities = citiesValue;
    countryIsoCode = countryIsoCodeValue;
}

function setCountryIsoCode(isoCode: string) {
    countryIsoCode = isoCode
}

function setCities(arg0: any[]) {
    cities = arg0;
}

function setStates(arg0: any[]) {
    states = arg0;
}

export const isJsonString = (str: string): boolean => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}



const getObjectOnChange = (name: string) => {
    switch (name) {
        case 'country':
            return true;
        case 'state':
            return true;
        case 'countryOfIncorporation':
            return true;
        default:
            return false;

    }
}

const getSelectValueKey = (name: string) => {
    switch (name) {
        case 'state':
            return "name";
        case 'countryOfIncorporation':
        case 'country':
        case 'citizenship':
            return "isoCode";
        case 'typeOfCompany':
            return 'name';

        default:
            return 'value';
    }
}

const getOnChangeFunctions = (name: string) => {
    switch (name) {
        case 'country':
            return (e: ICountry) => {
                setCountryIsoCode(e.isoCode);
                setStates(State.getStatesOfCountry(e.isoCode));
                setCities([{ name: 'Please select a state' }])
                store.dispatch(callRender())
            };
        // case 'state':
        //     return (e: ICountry) => {
        //         setCities(City.getCitiesOfState(countryIsoCode, e.isoCode));
        //         store.dispatch(callRender())
        //     };
        default:
            return undefined;

    }

}

const getSelectOptionsByName = (name: string) => {
    switch (name) {
        case 'countryOfIncorporation':
        case 'country':
        case 'citizenship':
            return countries;
        case 'city':
            return cities;
        case 'state':
            return states;
        case 'typeOfCompany':
            return types_roles;
        case 'portals':
            return portals;
        case 'jobFunction':
            return job_functions;
    }
}

export const getPolicyByPolicyID = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, policyId: string, valueKey?: string) => {
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const policyIndex = attributeInputCallback.getPolicies()['policyRequirements'].indexOf(policyId)
        if (!!valueKey) {
            if (policyIndex > -1) {
                const options = attributeInputCallback.getPolicies()['policies'][policyIndex]['params'][valueKey];
                return options
            }
        } else {
            if(!isNil( attributeInputCallback.getPolicies()['policies'][policyIndex])){
                return attributeInputCallback.getPolicies()['policies'][policyIndex]['params']
            }
           
        }
    }
    return undefined;
}

export const getNameValueJsonArray = (data: any) => {
    let jsonArrayObject: any[] = [];
    if (!!data) {
        if ((typeof data === 'string')) {
            if (data.indexOf('[') === -1) {
                jsonArrayObject.push({ 'name': data, 'value': data })
            } else {
                /**it is string of array */
                if (isJsonString(data)) {
                    const parsedJson = JSON.parse(data);
                    if (parsedJson.length) {
                        parsedJson.forEach((element: any) => {
                            if (element['_id'] && element['country'] && element['name']) {
                                jsonArrayObject.push({ 'name': element['name'] + "(" + element['country'] + ")", 'value': element['_id'] });
                            } else {
                                if(!!element['displayName']){
                                    jsonArrayObject.push({ 'name': element['displayName'], 'value': element['value'] });
                                } else {
                                    jsonArrayObject.push({ 'name': element['name'], 'value': element['value'] })
                                }
                            }
                        });
                    }
                } else {
                    data.slice(1, -1).split(',').forEach((value: any) => {
                        jsonArrayObject.push({ 'name': value, 'value': value });
                    })
                }

            }
        } else {
                data.forEach((value: any) => {
                    if (!!value){
                        if (value['_id'] && value['country'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] + "(" + value['country'] + ")", 'value': value['_id'] });
                        } else if (value['_id'] && value['registrationCode'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] + " ( " + value['registrationCode'] + " )", 'value': value['_id'] });
                        } else if (value['name'] && value['value']) {
                            jsonArrayObject.push({ 'name': value['name'], 'value': value['value'] });
                        } else if (typeof value === 'string') {
                            jsonArrayObject.push({ 'name': value, 'value': value });
                        } else if (value['_id'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] , 'value': value['_id'] });
                        } else {
                            console.error("data format for select options is wrong")
                        }
                    }
                })
        }
    }
    return jsonArrayObject;
}


 const getOptionsFromPolicy = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, uiType?: string) => {
    const options = getPolicyByPolicyID(attributeInputCallback, 'OPTIONS', 'values')
    if (!isNil(options)) {
        if (uiType === 'select') {
            return getNameValueJsonArray(options)
        } else {
            return options;
        }
    }
    return getSelectOptionsByName(attributeInputCallback.getName())

}
const getCustomGroups = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, formContext: any, test?: string) => {
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const groupDataType = attributeInputCallback.getPolicies()['policyRequirements'].indexOf("GROUP-DATA")
        if (groupDataType > -1) {
            const groupData = attributeInputCallback.getPolicies()['policies'][groupDataType]['params']['value'];

            const insideData = createAttributeCallBackType(!!groupData ? groupData : '{}');
            let childrenResult: JSX.Element[] = [];
            insideData.forEach(data => {
                const { children } = getUIElementsBasedOnType(data, formContext, false);
                childrenResult.push(children);
            })
            switch (attributeInputCallback.getName()) {
                default:
                    return (
                        <FormSection
                            sectionHeader={attributeInputCallback.getPrompt()} key={attributeInputCallback.getName() + "_group"}>
                            {childrenResult}
                        </FormSection>

                    )
            }
        }
    }
    return (<></>);
}

const validatedCreatePasswordCallback = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, value: any) => {
    let result: number = 0;
    const policies = getPolicyByPolicyID(attributeInputCallback, 'STRONG_PASSWORD_VALIDATION');
    let patterns: any[] = [];
    if(!isNil(policies)){
    Object.keys(policies).forEach((item) => {
        if (item !== "reqStrenght") {
            patterns.push(policies[item]);
        }
    });
    patterns.forEach(pattern => {
        if (value.match(pattern)) {
            result++;
        }
    })

    if (result < policies['reqStrenght']) {
        return getUItypeValidationMessage(attributeInputCallback, 'strongPasswordMessage');
    }
}
    return undefined;
}

const createAttributeCallBackType = (jsonString: string | undefined) => {
    if (!!jsonString) {
        const callBacks: Callback[] = JSON.parse(jsonString);
        const attributeInputCallBackArray: AttributeInputCallback<string | number | boolean>[] = [];
        callBacks.forEach(callback => attributeInputCallBackArray.push(new AttributeInputCallback(callback)))
        return attributeInputCallBackArray;
    }
    return [];

}

const getUItypeValidationMessage = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, validationMessageName?: string) => {
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const uiTypeIndex = attributeInputCallback.getPolicies()['policyRequirements'].indexOf("UI-TYPE")
        if (uiTypeIndex > -1) {
            const validationMessage = attributeInputCallback.getPolicies()['policies'][uiTypeIndex]['params'][!!validationMessageName ? validationMessageName : 'validationMessage'];
            if (!!validationMessage) {
                return validationMessage
            } else if (validationMessageName === 'minLength') {
                return undefined;
            } else if (validationMessageName === 'maxLength'){
                return undefined;
            }else {
                return 'Please enter a valid value';
            }
        }
    }

}

const getValidationMessage = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, value: any, validationValues?: { value: any[], message: string },validSecondaryEmail?:{ value: string, message: string }) => {
    const policies = attributeInputCallback.getPolicies()['policies'];

    let validation;
    if (!!value) {
        policies.forEach((policy: any) => {
            switch (policy['policyRequirements'][0]) {
                case 'MATCH_REGEXP':
                    const matches = new RegExp(policy['params']['regexp']).test(value);
                    validation = matches ? undefined : getUItypeValidationMessage(attributeInputCallback, 'regexMessage');
                    break;
                case 'INVALID-VALUES':
                    const invalid_values: any[] = policy['params']['values']
                    if (!isNil(invalid_values)) {
                        for (let i = 0; i < invalid_values.length; i++) {
                            if (!!value && value.indexOf(invalid_values[i]) > -1) {
                                validation = getUItypeValidationMessage(attributeInputCallback)
                            }
                        }
                    }
                    break;
                case 'MIN_LENGTH':
                    if (value.length < policy['params']['minLength']) {
                        const validationMessage = getUItypeValidationMessage(attributeInputCallback, 'minLengthMessage');
                        validation = validationMessage ? validationMessage : `Please enter more than ${policy['params']['minLength']} characters`
                    }
                    break;
                case 'MAX_LENGTH':
                        if (value.length > policy['params']['maxLength']) {
                            const validationMessage = getUItypeValidationMessage(attributeInputCallback, 'maxLengthMessage');
                            validation = validationMessage ? validationMessage : `Please enter less than ${policy['params']['maxLength']} characters`
                        }

            }
        });
        if (!validation && attributeInputCallback.getType() === CallbackType.ValidatedCreatePasswordCallback) {
            validation = validatedCreatePasswordCallback(attributeInputCallback, value);
        }
        if (!!validationValues && !validation) {
            let valid: boolean = false;
            validationValues.value.forEach(validationValue => {
                if (value.indexOf(validationValue) > -1) {
                    valid = true;
                }
            })
            if (!valid) {
                validation = validationValues.message;
            }
        }
        
        if (!!validSecondaryEmail && !validation) {
            let valid: boolean = false;
            if(value.toLowerCase() !== validSecondaryEmail.value.toLowerCase()){
                valid = true;
            }
            if (!valid) {
                validation = validSecondaryEmail.message;
            }
        }

        
    }

    return validation;
}


export const getUIElementsBasedOnType = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, formContext: any, isDisabled: boolean, validationValues?: { value: any[], message: string },validSecondaryEmail?:{value: string, message: string},termsAndConditionsText?:string, dependentViewMap?:any,metaDataMap?: any) => {
    // const { reRender, stateDisabled} = useAppSelector(reRenderSelector);
    let disabledState = undefined

    const attributeName = attributeInputCallback.getType() === CallbackType.TermsAndConditionsCallback ? 'terms' : attributeInputCallback.getName()
    const attributeWiseMapData = metaDataMap.get(attributeName)
    const halfwidth = attributeWiseMapData?.isHalfWidth
    
    if(dependentViewMap.has(attributeInputCallback.getName())){
        // console.log("depviewmap state current value",dependentViewMap?.get(attributeInputCallback.getName())?.currentValue, "attributeCallback",attributeInputCallback.getName());
        disabledState = dependentViewMap?.get(attributeInputCallback.getName())?.currentValue
    }
    let children: JSX.Element = <></>;
    let isGroupPart: boolean = false;
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const uiTypeIndex = attributeInputCallback.getPolicies()['policyRequirements'].indexOf("UI-TYPE")
        if (uiTypeIndex > -1) {
            const uiType = attributeInputCallback.getPolicies()['policies'][uiTypeIndex]['params']['types'];
            const required:boolean = attributeInputCallback.getPolicies()['policies'][uiTypeIndex]['params']['required'];
            switch (uiType) {
                case 'telephone':
                    children = (
                        <div style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight">
                            {/*  <span key={attributeInputCallback.getName() + 'fieldLabel'} className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                            <TelephoneInput
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                control={formContext.control}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                validation={{
                                    validate: (value: string) => {
                                        return getValidationMessage(attributeInputCallback, value, validationValues)
                                    }
                                }}
                                required={ar && required}
                                fullWidth
                            />
                        </div>);
                    break;
                case 'textArea':
                    children = (
                        <div>
                            <CustomTextField
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                validation={{
                                    validate: (value: string) => {
                                        return getValidationMessage(attributeInputCallback, value, validationValues);
                                    }
                                }}
                                multiline
                                minRows={4}
                                maxRows={4}
                                maxLength={getPolicyByPolicyID(attributeInputCallback, 'UI-TYPE', 'character_limit')}
                                inputProps={{ maxLength: getPolicyByPolicyID(attributeInputCallback, 'UI-TYPE', 'character_limit') }}
                                helperText={`${formContext.getValues(attributeInputCallback.getName())}/${getPolicyByPolicyID(attributeInputCallback, 'UI-TYPE', 'character_limit')}`}
                                margin="normal"
                                required={ar && required}
                                fullWidth
                            /></div>);
                    break;
                case "text":
                    children = (
                        <>
                            {/*    <span className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                            <CustomTextField style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                validation={{
                                    validate: (value: string) => {
                                        return getValidationMessage(attributeInputCallback, value, validationValues,validSecondaryEmail);
                                    }
                                }}
                                margin="normal"
                                required={ar && required}
                                fullWidth
                            />
                        </>);
                    break;
                case 'dropdown':
                case "select":
                    children = (<>
                        {/* <span key={attributeInputCallback.getName() + 'fieldLabel'} className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                        <CustomSelectField style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                            key={attributeInputCallback.getName()}
                            id={attributeInputCallback.getName()}
                            name={attributeInputCallback.getName()}
                            value={attributeInputCallback.getInputValue() as string}
                            disabled={isNil(disabledState) ? isDisabled : disabledState}
                            // disabled={(typeof disabled)==='string' ? store.getState()?.reRender.stateDisabled    : isDisabled}
                            label={attributeInputCallback.getPrompt()}
                            options={getOptionsFromPolicy(attributeInputCallback, uiType)}
                            onChange={getOnChangeFunctions(attributeInputCallback.getName())}
                            objectOnChange={getObjectOnChange(attributeInputCallback.getName())}
                            required={required}
                            validation={{
                                validate: (value: string) => {
                                    return getValidationMessage(attributeInputCallback, value, validationValues);
                                }
                            }}
                            halfWidth = {halfwidth}
                            valueKey={getSelectValueKey(attributeInputCallback.getName())}
                            labelKey="name" fullWidth margin="normal" />
                    </>)
                    break;
                case "multiCheckbox":
                    var options = getOptionsFromPolicy(attributeInputCallback, uiType)
                    children = (<>
                        <div style={{ marginBottom:'16px' }}><span dangerouslySetInnerHTML={{ __html: attributeInputCallback.getPrompt() }} className={styles.outsideValue}></span>{required ? "*" : ""}</div>
                        <div style={{ marginBottom:'16px' }}>
                        <CustomCheckBoxGroup 
                            name={attributeInputCallback.getName()}
                            options={options}
                            required={required}
                            />
                        </div>
                    </>)
                    break;
                case 'multiValueSelect':
                    children = (
                        < div  className="multiSelectText" style={{ marginTop: '0px', marginBottom: '16px' }}>
                            {/*  <span key={attributeInputCallback.getName() + 'fieldLabel'} className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                            {/* <MultiSelectElement
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                menuItems={getOptionsFromPolicy(attributeInputCallback)}
                                showChips={true}
                                showCheckbox
                                multiline
                                required={ar && required}
                                fullWidth
                            
                                /> 
                            */}
                            <CustomMultiSelectComponent
                                className="lowHeight multiSelectText"
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                options={getOptionsFromPolicy(attributeInputCallback)}
                                showChips={true}
                                showCheckbox
                                multiline
                                required={required}
                                fullWidth
                                
                            />
                        </div>);
                    break;
                case 'multiValueText':
                    children = (
                        <>
                            {/* <span key={attributeInputCallback.getName() + 'fieldLabel'} className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                            <MultivalueText style={{ marginTop: '0px', marginBottom: '16px' }} className="multiSelectText"
                                key={attributeInputCallback.getName()}
                                id={attributeInputCallback.getName()}
                                name={attributeInputCallback.getName()}
                                disabled={isDisabled}
                                label={attributeInputCallback.getPrompt()}
                                validation={{
                                    validate: (value: string[]) => {
                                        const validateValue = value[value.length - 1];
                                        return getValidationMessage(attributeInputCallback, validateValue, validationValues)
                                    }
                                }}
                                required={ar && required}
                                multiline
                                minRows={2}
                                maxRows={2}
                                fullWidth
                            /></>);
                    break;
                case 'radio':
                    children = (
                        <div style={{ width: '100%', marginTop: '0px', marginBottom: '16px' }} className="lowHeight"  >
                            <div>
                                <span dangerouslySetInnerHTML={{ __html: attributeInputCallback.getPrompt() }} className={styles.outsideValue}></span>{required ? "*" : ""}</div>
                            <CustomFormRadioGroup formContext={formContext}
                                // attributeInputCallback={attributeInputCallback}
                                name={attributeInputCallback.getName()}
                                row
                                required
                                valueType={typeof attributeInputCallback.getInputValue()}
                            ></CustomFormRadioGroup>
                        </div>)
                    break;
                case 'group':
                    isGroupPart = true;
                    children = getCustomGroups(attributeInputCallback, formContext);
                    break;
                case 'PasswordElementWithoutConfirm':
                    children = <CustomPasswordElement margin={'dense'}
                        key={attributeInputCallback.getPrompt()}
                        id={attributeInputCallback.getPrompt()}
                        name={attributeInputCallback.getPrompt()}
                        label={attributeInputCallback.getPrompt()}
                        required
                        fullWidth
                        validation={{
                            validate: (value: string) => {
                                return getValidationMessage(attributeInputCallback, value, validationValues);
                            }
                        }} />
                    break;
                    case 'PasswordElement':
                        children = <CustomPasswordElement margin={'dense'}
                            isWithRepeat={true}
                            key={attributeInputCallback.getPrompt()}
                            id={attributeInputCallback.getPrompt()}
                            name={attributeInputCallback.getPrompt()}
                            label={attributeInputCallback.getPrompt()}
                            required
                            fullWidth
                            validation={{
                                validate: (value: string) => {
                                    return getValidationMessage(attributeInputCallback, value, validationValues);
                                }
                            }} />
                        break;    

                default:
                    break;
            }
        } 
    }else {
        switch (attributeInputCallback.getType()) {
            case CallbackType.ValidatedCreatePasswordCallback:
                children = <CustomPasswordElement margin={'dense'}
                    key={attributeInputCallback.getName()}
                    id={attributeInputCallback.getName()}
                    name={attributeInputCallback.getName()}
                    label={attributeInputCallback.getPrompt()}
                    required
                    fullWidth
                    validation={{
                        validate: (value: string) => {
                            return getValidationMessage(attributeInputCallback, value, validationValues);
                        }
                    }} />
                    break;

            case CallbackType.TermsAndConditionsCallback:  
                    children = <CustomCheckBox
                    required
                    label={termsAndConditionsText}
                    name="termsAndConditions"
                     />
        }
    }
    return { children, isGroupPart };
}




